export const REDIRECT_REFERRER = Object.freeze('ssLogInReferral');
export const LOCAL_STORAGE_PLACE = "searchLocationPlace";
